import { baseSplitApi } from "../baseApi";
import { newLoginTag } from "../userAuth";

const regularizationRoute = '/attendance/regularize'

const getRegularizationStatus = `${regularizationRoute}/all_regularization`

const requestRegularizationRoute = `${regularizationRoute}/request_regularization`

const getManagerListRoute = `${regularizationRoute}/managers`

export const updateRegularizationStatusTag = 'changedRegularizationStatus'

export const regularizationApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        getRegularizationStatus: build.query({
            query: () => {
                return {
                    url: getRegularizationStatus,
                    method: 'GET'
                }
            },
            providesTags: [updateRegularizationStatusTag, newLoginTag]
        }),
        requestRegularization: build.mutation({
            query: (regularizationData) => {
                return {
                    url: requestRegularizationRoute,
                    method: 'POST',
                    body: regularizationData
                }
            },
            invalidatesTags: [updateRegularizationStatusTag]
        }),
        getManagerList: build.query({
            query: () => {
                return {
                    url: getManagerListRoute,
                    method: 'GET'
                }
            },
            transformResponse: (response) => response.departmentManagers
        })
    }),
    overrideExisting: false
})

export const { useGetRegularizationStatusQuery, useRequestRegularizationMutation, useGetManagerListQuery } = regularizationApi